import { render, staticRenderFns } from "./TabelaResultadosStatus.vue?vue&type=template&id=3ba8ee41&scoped=true&"
import script from "./TabelaResultadosStatus.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8ee41",
  null
  
)

export default component.exports